import React from 'react'
import Box from '@material-ui/core/Box'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import Radio from '@material-ui/core/Radio'
import PersonOutlineIcon from 'components/material-symbol/icons/PersonOutline'
import SupervisorAccountOutlinedIcon from 'components/material-symbol/icons/SupervisorAccount'
import { useStyles } from './styles'

const AgeChoiceCard = ({
  title,
  description,
  selected,
  onSelect,
  icon: Icon,
  testId,
  selectedTestId,
}) => {
  const classes = useStyles()

  return (
    <Box
      component="button"
      type="button"
      className={classes.ageChoiceCard}
      onClick={onSelect}
      data-testid={testId}
      aria-pressed={selected}
    >
      <Box className={classes.ageChoiceIcon}>
        <Icon />
      </Box>
      <Box className={classes.ageChoiceBody}>
        <Typography className={classes.ageChoiceTitle}>{title}</Typography>
        {description ? (
          <Typography className={classes.ageChoiceDescription}>
            {description}
          </Typography>
        ) : null}
      </Box>
      <Radio
        checked={selected}
        tabIndex={-1}
        color="default"
        inputProps={{
          'aria-hidden': true,
          ...(selected ? { 'data-testid': selectedTestId } : {}),
        }}
        classes={{
          root: classes.ageChoiceRadioRoot,
          checked: classes.ageChoiceRadioChecked,
        }}
      />
    </Box>
  )
}

export default function TileButtons({ isAdult, setIsAdult }) {
  const classes = useStyles()

  return (
    <Box className={classes.ageTiles}>
      <Typography className={classes.fieldLabel}>
        Is this student an adult (18+) or a junior (under 18)?
      </Typography>
      <Box className={classes.ageChoiceGroup}>
        <AgeChoiceCard
          title="Adult"
          description="Student is 18 years or older."
          selected={isAdult}
          onSelect={() => setIsAdult(true)}
          icon={PersonOutlineIcon}
          testId="student-age-adult-tile"
          selectedTestId="adult-selected"
        />
        <Divider className={classes.ageChoiceDivider} />
        <AgeChoiceCard
          title="Junior"
          description="Student is under 18 years old."
          selected={!isAdult}
          onSelect={() => setIsAdult(false)}
          icon={SupervisorAccountOutlinedIcon}
          testId="student-age-junior-tile"
          selectedTestId="junior-selected"
        />
      </Box>
    </Box>
  )
}
